// matomo-boot.js — G4: Matomo loader (classic script in <head>). The old Index.cshtml inline
// snippet, ported verbatim in behaviour: document title prefixed with the domain, Do-Not-Track
// honoured, one page view + outbound/download link tracking. Site id and URLs come from data-*.
(function () {
  var me = document.currentScript;
  if (!me) return;
  var siteId = me.getAttribute('data-site-id');
  var trackerUrl = me.getAttribute('data-tracker-url');
  var scriptUrl = me.getAttribute('data-script-url');
  var cookieDomain = me.getAttribute('data-cookie-domain');
  if (!siteId || !trackerUrl || !scriptUrl) return;

  var _paq = (window._paq = window._paq || []);
  // Tracker methods like setCustomDimension must be called before trackPageView.
  _paq.push(['setDocumentTitle', document.domain + '/' + document.title]);
  if (cookieDomain) _paq.push(['setCookieDomain', cookieDomain]);
  _paq.push(['setDoNotTrack', true]);
  _paq.push(['trackPageView']);
  _paq.push(['enableLinkTracking']);
  _paq.push(['setTrackerUrl', trackerUrl]);
  _paq.push(['setSiteId', siteId]);

  var g = document.createElement('script');
  g.async = true;
  g.src = scriptUrl;
  var first = document.getElementsByTagName('script')[0];
  first.parentNode.insertBefore(g, first);
})();
